export const api = {
  sts: 'https://api-stage.playhunch.io/',
  dev: 'https://api.hunch-dev.polytech.rocks/',
  prod: 'https://api.playhunch.io/'
}
